<template>
	<el-dialog :title="title" :visible.sync="mdVisible" append-to-body :destroy-on-close="true" @close="handleCancel"
		:closeOnClickModal="false" width="40%" top="0vh" custom-class="center-dialog" :lock-scroll="false">
		<div class="popMain">
			<div class="popMainTitle">
				<h1>中国勘察设计协会理事长朱长喜领导一行代表到访广联达考察交流</h1>
				<p>发布时间：2023-03-07 15:00:00</p>
			</div>
			<div class="popMainItem">
				<p>
					3月1日，北京市科学技术委员会、中关村科技园区管理委员会文化科技处处长李焱携北京科技创新促进中心文化科技与科普工作部副部长楼晓红、主管工程师孙蕾、通州区科委副主任王本禄、北京建筑大学结构工程二级学科负责人张艳霞、北京工业大学科发院副院长刘占省、北京市建筑设计研究院有限公司信息部部长梁楠等专家领导到广联达科技股份有限公司（以下简称“广联达”）进行调研交流。
				</p>
				<img src="../../../assets/img/newsListD1.png" alt="">
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				mdVisible: false,
				title: ""
			};
		},
		methods: {
			show() {
				this.mdVisible = true
			},
			close() {
				this.mdVisible = false
			},
			handleCancel() {
				this.close()
			}
		},
	}
</script>

<style lang="scss">
	// 控制的dialog样式需要穿透到底层，所以这里不能写scoped属性
	// 如果不想影响全局，可以给el-dialog的父级定义一个class,再把.center-dialog置于这个class的嵌套里面
	.center-dialog {
		top: 50%;
		transform: translateY(-50%);
		border-radius: 10px;
	}

	.popMain {
		height: 60vh;
		overflow-y: auto;
		padding: 0 20px;

		.popMainTitle {
			border-bottom: 1px #ddd solid;
			padding-bottom: 10px;

			h1 {
				margin-bottom: 8px;
				color: #333;
				font-size: 22px;
				font-weight: normal;
				line-height: 30px;
			}

			p {
				font-size: 14px;
				color: #999;
				display: inline-block;
			}
		}

		// popMainItem内容开始
		.popMainItem {
			padding-top: 15px;

			p {
				font-size: 16px;
				// color: #333;
				color: #404040;
				line-height: 28px;
			}

			img {
				width: 100%;
				margin: 16px 0;

			}
		}

		// popMainItem内容结束
	}


	/*滚动条样式*/
	.popMain::-webkit-scrollbar {
		width: 4.5px; //纵向滚动条的宽度
	}

	.popMain::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		background: rgba(0, 0, 0, 0.08);
	}

	// .popMain::-webkit-scrollbar-track {
	// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
	// 	border-radius: 0;
	// 	background: rgba(0, 0, 0, 0.08);
	// }

	/*滚动条样式*/


	// 修改弹窗样式
	.center-dialog .el-dialog__header {
		padding: 0px;
	}

	.center-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	.center-dialog .el-dialog__body {
		padding: 30px 10px;
		padding-top: 40px;
	}

	.center-dialog .el-dialog__headerbtn .el-dialog__close {
		font-weight: 600;
	}
</style>
<style>
	/deep/ .el-dialog__wrapper {
		overflow: hidden;
	}

	/deep/ .el-popup-parent--hidden {
		padding-right: 0 !important;
	}
	
	/* /deep/ .el-dialog {
		background: rgba(238, 241, 249, 0.96);
	} */
</style>
